export const BRIDGE_CUSTOMER_ID_REGEX = /^\d{3}-\d{3}-\d{4}$/;
export const BRIDGE_CUSTOMER_ID_LABEL = 'Account ID (123-456-7890)';
export const BRIDGE_CUSTOMER_ID_MESSAGE = 'Account ID must look like 123-456-7890. Fix the Account ID in Ad Accounts.';
